import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const adminApi = axios.create({ baseURL: `${BASE}/api/admin` });

adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("sq_admin_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

const AdminCtx = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("sq_admin_token");
    if (!t) { setLoading(false); return; }
    adminApi.get("/me").then((r) => setAdmin(r.data)).catch(() => localStorage.removeItem("sq_admin_token")).finally(() => setLoading(false));
  }, []);

  const login = (token, a) => { localStorage.setItem("sq_admin_token", token); setAdmin(a); };
  const logout = () => { localStorage.removeItem("sq_admin_token"); setAdmin(null); };

  return <AdminCtx.Provider value={{ admin, loading, login, logout }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
